import { useState } from 'react'
import SponsorService from '../services/SponsorService'
import { toastError } from '../../../config/global'

export default function useRequestsActions() {
  const [inProgress, setInProgress] = useState(false)

  async function createSponsorRequest(payload) {
    try {
      setInProgress(true)
      const { data } = await SponsorService.createSponsorRequest(payload)
      return data.message
    } catch (error) {
      if (!error.response && !error.request) {
        toastError('لم يتم الاتصال بالخادم. يرجى التحقق من الاتصال بالإنترنت.')
      } else if (error.response) {
        toastError(error.response.data.error)
      } else if (error.request) {
        toastError('لم يتم استلام استجابة من الخادم. حاول مرة أخرى لاحقًا.')
      } else {
        toastError('حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.')
      }
    } finally {
      setInProgress(false)
    }
  }
  return { createSponsorRequest, inProgress }
}
